import { NavProvider } from './src/providers/navContext';

// Staging-only diagnostics. Logs a single line on app boot describing the
// build (Sanity dataset, project, git branch, build time, API endpoint) so
// it's obvious from the browser console whether the right pipeline produced
// the page. The block is gated by the build-time GATSBY_SANITY_DATASET so
// production builds never include it.
if (
  typeof process !== 'undefined' &&
  process.env.GATSBY_SANITY_DATASET === 'staging' &&
  typeof window !== 'undefined'
) {
  console.log(
    '%c[marianagomes staging]',
    'background:#5d5f60;color:#fff;padding:2px 6px;border-radius:3px;font-weight:600',
    {
      sanityDataset: process.env.GATSBY_SANITY_DATASET,
      sanityProjectId: process.env.GATSBY_SANITY_ID,
      apiEndpoint: process.env.GATSBY_API_ENDPOINT,
      gitBranch: process.env.GATSBY_GIT_BRANCH ?? '(unset)',
      buildTime: process.env.GATSBY_BUILD_TIME ?? '(unset)'
    }
  );
}

export function wrapRootElement({ element }: { element: React.ReactNode }) {
  return <NavProvider>{element}</NavProvider>;
}
